import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useIsCheckoutPage = () => {
  const { pathname } = useLocation();

  return useMemo(
    () =>
      [
        '/cases/new/checkout/shipping',
        '/cases/new/checkout/billing',
        '/cases/new/checkout/review',
      ].includes(pathname),
    [pathname]
  );
};
